// @flow
import api from 'tim-api';

export const state = {
  listProduct: []
};

export const getters = {
  listProductGetter: (state: Object) => state.listProduct
};

export const mutations = {
  SET_LIST_PRODUCT(state: Object, listProduct: Array<Object>) {
    state.listProduct = listProduct;
  }
};

export const actions = {
  fetchList({ commit }: Action) {
    commit('SET_LIST_PRODUCT', []);
    return api.get('goals/segments/for-planning').then(({ data }) => {
      commit('SET_LIST_PRODUCT', data);
    });
  },
  // eslint-disable-next-line
  saveProducts({ commit }: Action, products: Array<number>) {
    return api.post('channel-segments', { segment_ids: products });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
